// 登录后回到哪里。站内跳转靠路由 state；飞书网页授权会整页跳走再回来，state 会丢，所以跳走前记进 sessionStorage。
// 只认站内相对路径，防止被拿来跳到别的网站；记下的地址 15 分钟后作废。

const KEY = 'lingzhi.login.return'
const TTL_MS = 15 * 60_000

const safe = (p: unknown): p is string =>
  typeof p === 'string' && p.startsWith('/') && !p.startsWith('//') && !p.startsWith('/\\') && !/^\/login(?:[/?#]|$)/.test(p)

export function rememberReturn(path: string | undefined) {
  try {
    if (safe(path)) sessionStorage.setItem(KEY, JSON.stringify({ path, at: Date.now() }))
  } catch {
    /* 隐私模式下存不了：登录后回首页 */
  }
}

function stored(consume: boolean): string | undefined {
  try {
    const raw = sessionStorage.getItem(KEY)
    if (consume) sessionStorage.removeItem(KEY)
    const v = raw ? (JSON.parse(raw) as { path?: unknown; at?: unknown }) : null
    return v && safe(v.path) && typeof v.at === 'number' && Date.now() - v.at < TTL_MS ? v.path : undefined
  } catch {
    return undefined
  }
}

/** 登录完成后去哪：本次路由带来的 from 优先，其次飞书跳转前记下的，最后首页。consume=false 只看不取（渲染时用）。 */
export function loginDestination(from: string | undefined, consume = true) {
  const kept = stored(consume)
  return safe(from) ? from : kept ?? '/'
}
